import { useQuery } from '@tanstack/react-query';
import type { CursorPage, Forecast } from '@seo/types';
import { apiGet } from '@/lib/api';

export function useForecasts(projectId?: string, limit = 50) {
  const params = new URLSearchParams();
  if (projectId) params.set('project_id', projectId);
  params.set('limit', String(limit));
  return useQuery({
    queryKey: ['forecasts', { projectId, limit }],
    queryFn: () => apiGet<CursorPage<Forecast>>(`/v1/forecasts?${params.toString()}`),
  });
}
